import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutUs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-story">
          <p>{t('about.story.paragraph1')}</p>
          <p>{t('about.story.paragraph2')}</p>
          <p className="founder-signature">— {t('about.founder.name')}, {t('about.founder.title')}</p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
